<form class="mct-flex mct-col mct-gap-27" #editForm="ngForm">
  <div class="mct-justify-between mct-items-center mct-flex mct-row">
    <div>
      {{ 'form-builder.donation-form.title' | translate | titlecase }}
    </div>
    <div class="mct-flex mct-row mct-gap-4">
      <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="openSettings()">
        <span class="pi pi-plus"></span>
        {{ 'form-builder.form-settings.title' | translate | titlecase }}
      </button>
      <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="addFormElementClicked()">
        <span class="pi pi-plus"></span>
        {{ 'form-builder.new-form-element' | translate | titlecase }}
      </button>
    </div>
  </div>
  <div class="mct-grid-gt-sm form-build-title-row">
    <input
      name="formTitle"
      class="form-control"
      [(ngModel)]="donationFormTemplate.Title"
      [placeholder]="'form-builder.form-title' | translate | ucfirst"
    />
    <div class="mct-flex mct-justify-end mct-items-center mct-gap-27" *ngIf="editId">
      <a data-cy="adonationFormActivation" (click)="toggleActive()">
        {{ (inactive ? 'form-builder.activate' : 'form-builder.deactivate') | translate | titlecase }}
      </a>
      <a [href]="formViewerUrl" [target]="'_blank'">{{ 'form-builder.view-donation-form' | translate | titlecase }}</a>
      <a [routerLink]="['/form-builder/form', editId, 'submissions']">{{ 'form-builder.view-submissions' | translate | titlecase }}</a>
    </div>
  </div>
  <div class="mct-flex mct-col" *ngFor="let formElement of donationFormTemplate?.FormElements; let i = index">
    <hr />
    <div class="mt-11 wl-show-on-hover-container mct-grid-gt-sm form-build-element-row mct-gap-27">
      <div *ngIf="formElement.ElementType === elementType.Header">
        <h1>
          {{ formElement.DisplayValue }}
        </h1>
        <label>
          {{ formElement.DisplayValue2 }}
        </label>
      </div>
      <div *ngIf="formElement.ElementType === elementType.TextBlock">
        <wl-html-content-view [html]="formElement.DisplayValue"></wl-html-content-view>
      </div>
      <div *ngIf="formElement.ElementType === elementType.ProfileIndividual || formElement.ElementType === elementType.ProfileOrganization">
        <wl-profile-lego-summary [profileData]="formElement.MetaData.ProfileData"></wl-profile-lego-summary>
      </div>
      <div *ngIf="formElement.ElementType === elementType.PurchaseItem">
        <wl-purchase-item-lego-summary [purchaseItemData]="formElement.MetaData.PurchaseItemData"></wl-purchase-item-lego-summary>
      </div>
      <div *ngIf="formElement.ElementType === elementType.CustomField">
        <wl-custom-field-lego-summary [(customFieldData)]="formElement.MetaData.CustomFieldData"></wl-custom-field-lego-summary>
      </div>
      <div *ngIf="formElement.ElementType === elementType.AffiliationCode">
        <wl-affiliation-code-lego-summary
          [(affiliationCodeData)]="formElement.MetaData.AffiliationCodeData"
        ></wl-affiliation-code-lego-summary>
      </div>
      <div *ngIf="formElement.ElementType === elementType.FileUpload">
        <wl-file-upload-lego-summary [fileUploadData]="formElement.MetaData.FileUploadData"></wl-file-upload-lego-summary>
      </div>
      <div *ngIf="formElement.ElementType === elementType.OpenField">
        <wl-open-field-lego-summary [openFieldData]="formElement.MetaData.OpenFieldData"></wl-open-field-lego-summary>
      </div>
      <div class="mct-flex mct-justify-start mct-items-center p-4">
        <button class="atlas-btn atlas-btn-default" pButton type="button" (click)="editFormElementClicked(formElement)">
          {{ 'common.edit' | translate | titlecase }}
        </button>
        <button class="atlas-btn atlas-btn-default" pButton type="button" (click)="removeClicked(i)">
          {{ 'common.remove' | translate | titlecase }}
        </button>
        <button
          class="atlas-btn atlas-btn-default"
          pButton
          type="button"
          title="{{ 'common.move' | translate | titlecase }} {{ 'common.up' | translate | titlecase }}"
          (click)="moveUp(i)"
          icon="pi pi-arrow-up"
          [pTooltip]="('common.move' | translate | titlecase) + ' ' + ('common.down' | translate | titlecase)"
          tooltipPosition="top"
        ></button>
        <button
          class="atlas-btn atlas-btn-default"
          pButton
          type="button"
          title="{{ 'common.move' | translate | titlecase }} {{ 'common.down' | translate | titlecase }}"
          (click)="moveDown(i)"
          icon="pi pi-arrow-down"
          [pTooltip]="('common.move' | translate | titlecase) + ' ' + ('common.down' | translate | titlecase)"
          tooltipPosition="top"
        ></button>
      </div>
      <div class="mct-flex mct-justify-start mct-items-center p-4">
        <button pButton type="button" class="atlas-btn atlas-btn-primary wl-show-on-hover" (click)="insertFormElementClicked(i)">
          <span class="pi pi-plus"></span>
          {{ 'form-builder.new-form-element' | translate | titlecase }}
        </button>
      </div>
    </div>
  </div>
  <hr />
  <div class="mct-flex mct-row mct-justify-between mct-items-center">
    <button pButton type="button" data-cy="buttonDonationFormEditSave" class="atlas-btn atlas-btn-primary" (click)="saveClicked()">
      <span class="pi pi-plus"></span>
      {{ 'common.save' | translate | titlecase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="addFormElementClicked()">
      <span class="pi pi-plus"></span>
      {{ 'form-builder.new-form-element' | translate | titlecase }}
    </button>
  </div>
  <p-dialog modal="true" styleClass="atlas-dialog-m" position="top" [closable]="false" [(visible)]="showSettings">
    <ng-template pTemplate="header">
      <h4>
        {{ 'form-builder.donation-form.settings-header' | translate | titlecase }}
      </h4>
    </ng-template>
    <wl-form-settings [formSettings]="formSettings" [allowProfileBehavior]="true" [(showEditor)]="showSettings" showLoginOptions="true">
    </wl-form-settings>
    <ng-template pTemplate="footer">
      <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="cancelSettings()">
        {{ 'common.cancel' | translate | uppercase }}
      </button>
      <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="saveSettings()">
        <span>{{ 'common.done' | translate | uppercase }}</span>
      </button>
    </ng-template>
  </p-dialog>
</form>

<wl-form-v2-element-edit [formType]="formType.Donation" (saveClicked)="elementSaveClicked($event)"></wl-form-v2-element-edit>
